import React from "react";

const defaultHeaderConfig = {
  logo: false,
  home: false,
  title: "",
};
export const privateRoutes = [
  {
    Path: "/",
    Component: React.lazy(() => import("../container/Home")),
    meta: {
      name: "Home Page",
    },
    headerConfig: {
      ...defaultHeaderConfig,
      home: false,
      logo: true,
    },
    id: "home",
  },
];

// eslint-disable-next-line
export default { privateRoutes };
